import PropTypes from "prop-types"
import React from "react"
import Modal from "components/Modal"
import YoutubeVideo from "components/YoutubeVideo"
import * as css from "./YoutubeModal.module.css"

function YoutubeModal({ url, closeModal, autoPlay }) {
  return (
    <Modal onClose={closeModal} size="large">
      <div className={css.wrapper}>
        <YoutubeVideo url={url} autoPlay={autoPlay} />
      </div>
    </Modal>
  )
}

YoutubeModal.propTypes = {
  /** YouTube video URL */
  url: PropTypes.string,
  /** onClose callback */
  closeModal: PropTypes.func,
  /** If true, play the video on open modal */
  autoPlay: PropTypes.bool,
}

export default YoutubeModal
